import { CountryChangeButton } from '@skin-seoul/shared-components';
import type { Country } from '@skin-seoul/service';
import { useRegionCurrency } from '@skin-seoul/service';
import { useEffect } from 'react';

interface CountryChangeShortcodeProps {
  initialCountry?: Country;
}

const CountryChangeShortcode = ({ initialCountry }: CountryChangeShortcodeProps) => {
  const { country, setCountry } = useRegionCurrency();

  // Set initial country if provided via props
  useEffect(() => {
    if (initialCountry && initialCountry !== country) {
      setCountry(initialCountry);
    }
  }, [initialCountry, country, setCountry]);

  const handleCountryChange = (newCountry: Country) => {
    setCountry(newCountry);
  };

  return (
    <div className="flex w-full items-center justify-center box-border p-2">
      <CountryChangeButton country={country} onCountryChange={handleCountryChange} />
    </div>
  );
};

export default CountryChangeShortcode;
